import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertError, apiV2Request } from "../apiV2Request";

export const useBusinessUserCreditAccess = (businessId: number) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: { message: string }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `businesses/${businessId}/request-credit-access`,
        data,
      }).then((response) => apiV2AssertError(response)),
  });
};
